/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default { 
    GET_ALL_SHIFTTYPE(state, shifttypes) {
        state.getAllShiftType = shifttypes
    },
    GET_ALL_SCHEDULETYPE(state, scheduletypes) {
        state.getAllScheduleType = scheduletypes
    },
    GET_ALL_SEGMENTTYPE(state, segmenttypes) {
        state.getAllSegmentType = segmenttypes
    },
    GET_ALL_LEAVETYPE(state, leaveType) {
        state.getAllLeaveTypes = leaveType
    },
    GET_ALL_CLAIMCATEGORY(state, claimsCategory) {
        state.claimsCategory = claimsCategory
    },
    GET_ALL_CLAIMSUBCATEGORY(state, claimsSubCategory) {
        state.claimsSubCategory = claimsSubCategory
    },
    GET_ALL_LOANTYPE(state, loanType) {
        state.getAllLoanType = loanType
    },
    GET_ALL_LOANNAME(state, loanName) {
        state.getAllLoanName = loanName
    },
    GET_ALL_LOANCATEGORY(state, loanCategory) {
        state.loanCategory = loanCategory
    },
    
    GET_ALL_LOANSUBCATEGORY(state, loanSubCategory) {
        state.loanSubCategory = loanSubCategory
    },
    ADD_LoanSubCategory(state, payload) {
        state.loanSubCategory.push(payload)
        console.log(state.loanSubCategory)
    },
    UPDATE_LoanSubCategory(state, items) {
        const index = state.loanSubCategory.findIndex((e) => e.loanSubCategoryId === items.loanSubCategoryId)
        Object.assign(state.loanSubCategory[index], {loanSubCategoryCode: items.loanSubCategoryCode, 
            loanSubCategoryName: items.loanSubCategoryName, 
            loanCategoryId: items.loanCategoryId})
    },
    DELETE_LoanSubCategory(state, id) {
        const index = state.loanSubCategory.findIndex((e) => e.loanSubCategoryId === id)
        state.loanSubCategory.splice(index, 1)
    },
    GET_ALL_OVERTIMETYPE(state, overtimeType) {
        state.overtimeTypes = overtimeType
    },
    UPLOAD_PHOTO(state, photo){
        state.photoUpload.unshift(photo)
    },
    GET_ALL_Department(state, payload) {
        state.getAllDepartment = payload
    },
    GET_ALL_Branch(state, payload) {
        state.getAllBranch = payload
    },
    GET_ALL_Position(state, payload) {
        state.getAllPosition = payload
    },
    GET_ALL_Division(state, payload) {
        state.getAllDivision = payload
    },
    GET_ALL_Section(state, payload) {
        state.getAllSection = payload
    },
    GET_ALL_EmployeeCategory(state, payload) {
        state.getAllEmployeeCategory = payload
    },
    GET_ALL_EarningsType(state, payload) {
        state.getAllEarningsType = payload
    },
    ADD_EarningsType(state, payload) {
        state.getAllEarningsType.push(payload)
    },
    UPDATE_EarningsType(state, items) {
        const index = state.getAllEarningsType.findIndex((e) => e.earningsTypeId === items.earningsTypeId)
        Object.assign(state.getAllEarningsType[index], {earningsTypeCode: items.earningsTypeCode, 
            earningsTypeName: items.earningsTypeName, 
            earningsCategoryId: items.earningsCategoryId, 
            isTaxable: items.isTaxable,
            isBonus: items.isBonus,
            addTo: items.addTo})
    },
    DELETE_EarningsType(state, id) {
        const index = state.getAllEarningsType.findIndex((e) => e.earningsTypeId === id)
        state.getAllEarningsType.splice(index, 1)
    },
    GET_ALL_EarningsCategory(state, payload) {
        state.getAllEarningsCategory = payload
    },
    GET_ALL_DeductionsType(state, payload) {
        state.getAllDeductionsType = payload
    },
    ADD_DeductionsType(state, payload) {
       
        // state.getAllDeductionsType = payload
        state.getAllDeductionsType.push(payload)
        console.log(state.getAllDeductionsType)
    },
    UPDATE_DeductionsType(state, items) {
        const index = state.getAllDeductionsType.findIndex((e) => e.deductionsTypeId === items.deductionsTypeId)
        Object.assign(state.getAllDeductionsType[index], { deductionsTypeCode: items.deductionsTypeCode, 
            deductionsTypeName: items.deductionsTypeName, 
            deductionsCategoryId: items.deductionsCategoryId, 
            isTaxable: items.isTaxable,
            isBonus: items.isBonus,
            addTo: items.addTo})
    },
    DELETE_DeductionsType(state, id) {
        const index = state.getAllDeductionsType.findIndex((e) => e.DeductionsTypeId === id)
        state.getAllDeductionsType.splice(index, 1)
    },
    GET_ALL_DeductionsCategory(state, payload) {
        state.getAllDeductionsCategory = payload
    },
    GET_ALL_CivilStatus(state, payload) {
        state.getAllCivilStatus = payload
    },
    GET_ALL_Nationality(state, payload) {
        state.getAllNationality = payload
    },
    GET_ALL_Religion(state, payload) {
        state.getAllReligion = payload
    },
    GET_ALL_Relationship(state, payload) {
        state.getAllRelationshipLookup = payload
    },
    GET_ALL_AccreditationType(state, payload) {
        state.getAllAccreditationType = payload
    },
    GET_ALL_Rank(state, payload) {
        state.getAllRankLookup = payload
    },
    GET_ALL_Association(state, payload) {
        state.getAllAssociationLookup = payload
    },
    GET_ALL_Bank(state, payload) {
        state.getAllBankLookup = payload
    },
    GET_ALL_Period(state, payload) {
        state.getAllPeriodLookup = payload
    },
    GET_ALL_BenefitType(state, payload) {
        state.getAllBenefitTypeLookup = payload
    },
    GET_ALL_LineOfBusiness(state, payload) {
        state.getAllLineOfBusinessLookup = payload
    },
    GET_ALL_Degree(state, payload) {
        state.getAllDegreeLookup = payload
    },
    GET_ALL_AreaOfStudy(state, payload) {
        state.getAllAreaOfStudyLookup = payload
    },
    GET_ALL_Institution(state, payload) {
        state.getAllInstitutionLookup = payload
    },
    GET_ALL_Award(state, payload) {
        state.getAllAwardLookup = payload
    },
    GET_ALL_MarketSegment(state, payload) {
        state.getAllMarketSegmentLookup = payload
    },
    GET_ALL_AppraisalType(state, payload) {
        state.getAllAppraisalTypeLookup = payload
    },
    GET_ALL_AppraisalRating(state, payload) {
        state.getAllAppraisalRatingLookup = payload
    },
    GET_ALL_SalaryBasedOn(state, payload) {
        state.getAllSalaryBasedOnLookup = payload
    },
    GET_ALL_ScheduleNumber(state, payload) {
        state.getAllScheduleNumber = payload
    },
    GET_ALL_TaxReference(state, payload) {
        state.getAllTaxReferenceLookup = payload
    },
    GET_ALL_PaymentMode(state, payload) {
        state.getAllPaymentModeLookup = payload
    },
    GET_ALL_Violation(state, payload) {
        state.getAllViolationLookup = payload
    },
    GET_ALL_ViolationAction(state, payload) {
        state.getAllViolationActionLookup = payload
    },
    GET_ALL_MedicalProcedure(state, payload) {
        state.getAllMedicalProcedureLookup = payload
    },
    GET_ALL_Country(state, payload) {
        state.getAllCountryLookup = payload
    },
    GET_ALL_CreatePayrollType(state, payload) {
        state.getAllCreatePayrollTypeLookup = payload
    },
}